import React, {useEffect, useRef, useState} from "react";
import {Link} from "gatsby";
import ArrowLink from "../global/arrow-link";
import {GatsbyImage} from "gatsby-plugin-image";
import SocialLinks from "./social-links";

const DetailsFooter = (
  {
    imageData = null,
    imageDataHover = null,
    linkData = {},
    pre_title = "",
    title = "",
  }
) => {
  const parentRef = useRef();
  const [isHover, setHoverState] = useState(false);

  const parentMouseEnterHandler = () => {
    setHoverState(true);
  }

  const parentMouseLeaveHandler = (event) => {
    if ( parentRef?.current.contains(event.relatedTarget) ) {
      return;
    }

    setHoverState(false);
  }

  return (
    <section
      className="details-footer"
      onMouseOver={parentMouseEnterHandler}
      onMouseOut={parentMouseLeaveHandler}
      ref={parentRef}
    >
      <Link
        className="details-footer__link-container"
        to={linkData.project_url}
      >
        <div className="details-footer__top">
          <div className={`details-footer__image-container details-footer__image-container--image-1 ${isHover ? 'mouseEnter' : 'mouseLeave'}`}>
            <GatsbyImage
              className="details-footer__image"
              image={imageData}
              alt="Evo"
            />
          </div>
          <div className={`details-footer__image-container details-footer__image-container--image-2 ${isHover ? 'mouseEnter' : 'mouseLeave'}`}>
            <GatsbyImage
              className="details-footer__image details-footer__image--hover-image"
              image={imageDataHover}
              alt="Evo"
            />
          </div>
          <div
            className="details-footer__content-container"
          >
            <div className="container">
              <div className="row">
                <div className="col-12 col-lg-4 offset-lg-7">
                  <div className="details-footer__content-wrapper">
                    <div className="details-footer__pre-title">{pre_title}</div>
                    <h4 className="details-footer__title">{title}</h4>
                    <div className="details-footer__link-wrapper">
                      <ArrowLink
                        className="details-footer__arrow-link"
                        text={linkData.title}
                        isLink={false}
                        isAnimation={isHover}
                        transitionDuration={600}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Link>
      <div
        className="details-footer__bottom-container"
      >
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="details-footer__copy-container">
                <div className="details-footer__copy">
                  <span>
                    &copy; { new Date().getFullYear() } evo | <a className="details-footer__copy-link" href="https://www.evo.com/what-is-your-privacy-policy" target="_blank">Privacy Policy</a> | <a className="details-footer__copy-link" href="https://evo.com" target="_blank">evo.com</a>
                  </span>
                </div>
                <div className="details-footer__social-wrapper">
                  <SocialLinks />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default DetailsFooter
